import axiosClient from "api/apiClient";

export const APIUpdateProfile = (data: object) => {
  return axiosClient.post(`/profile`, data, {
        headers: {
          'Content-Type': 'multipart/form-data', // Axios should handle this automatically
        },
      }
  );
};

export const APIGetProfile = () => {
  return axiosClient.get(`/profile`);
};
